module.exports = __webpack_public_path__ + "static/media/language_PL.08744998.svg";